import { useMemo } from 'react';
import { filter } from 'lodash';
import { Tab, TabPanel } from 'tuui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { StepNavigator } from '../config/StepNavigator';
import { conversionTabItems } from '../config/conversionTabItems';
import { useConversions } from './useConversions';
import { useCurrentConversion } from './useCurrentConversion';
import styles from '../components/conversionSetup.module.scss';

export const useTabHeadersAndContent = (
    conversions,
    switchTab,
    currentStep,
    goNext,
    goBack,
    handleSetCurrentIndex,
    currentIndex,
    resetSteps,
    handleEditClick,
    setFocusedConversionId,
    existingConversionIds
) => {
    const tabHeaders = useMemo(
        () =>
            conversionTabItems.map(({ caption, id }, tabIndex) => (
                <Tab key={id} className={styles['tab-headers']} onClick={() => switchTab(tabIndex)}>
                    <FormattedMessage id={caption.id} defaultMessage={caption.defaultMessage} />
                </Tab>
            )),
        [switchTab]
    );

    const { touchedConversions, untouchedConversions } = useConversions();
    const currentConversion = useCurrentConversion(currentIndex);

    const existingConversions = filter(conversions, conversion => existingConversionIds.includes(conversion.id));

    const tabContent = useMemo(
        () =>
            conversionTabItems.map(({ renderSteps, id }) => {
                const props = {
                    touchedConversions,
                    untouchedConversions,
                    currentConversion,
                    existingConversions,
                    conversions,
                };
                const steps = renderSteps(props);
                return (
                    <TabPanel key={id}>
                        <StepNavigator
                            steps={steps}
                            currentStep={currentStep}
                            goNext={goNext}
                            goBack={goBack}
                            resetSteps={resetSteps}
                            handleSetCurrentIndex={handleSetCurrentIndex}
                            currentIndex={currentIndex}
                            handleEditClick={handleEditClick}
                            setFocusedConversionId={setFocusedConversionId}
                        />
                    </TabPanel>
                );
            }),
        [
            touchedConversions,
            untouchedConversions,
            currentConversion,
            existingConversions,
            conversions,
            currentStep,
            goNext,
            goBack,
            resetSteps,
            handleSetCurrentIndex,
            currentIndex,
            handleEditClick,
            setFocusedConversionId,
        ]
    );

    return { tabHeaders, tabContent };
};
